import React from 'react';
import { connect } from 'react-redux';
import { push, replace} from 'react-router-redux';
import { Link } from 'react-router';
import {
  loadFeaturedOrganizationFromDB
} from '../actions';
import OrganizationDetailBanner from '../components/OrganizationDetailBanner';
import OrganizationFavBtn from '../components/OrganizationFavBtn';
import OrganizationDetailShareButtons from '../components/OrganizationDetailShareButtons';
import OrganizationDetailTextSection from '../components/OrganizationDetailTextSection';
import OrganizationDetailConnectSection from '../components/OrganizationDetailConnectSection';
import { FBPage } from 'facebook-plugins';
import { isEmpty } from 'lodash/lang';
import OrganizationDetailLocationSection from '../components/OrganizationDetailLocationSection';



class OrganizationDetailFromDB extends React.Component{
  
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadFeaturedOrganizationFromDB(this.props.router.params.id);
  }

  render() {
    const { featuredOrgFromDB, browser } = this.props;
    if (this.props.isLoading) {
      return <span>loading...</span>
    }

    let organization = featuredOrgFromDB;

    const regions = organization.region_names;
    let region = '';

    const googleMapKey = 'AIzaSyA3Xg-_aRZsRtgBGg38S7SQQhjjEaIOVUg';

    let mapUrl = '';
    let fullAddress = '';
    if (!isEmpty(regions)) {
      for (var i = regions.length - 1; i > -1; i--) {
        if (i == 0) {
          fullAddress += regions[i];
        } else {
          fullAddress += regions[i] + ', ';
        }
      }
    }

    // If organization has no address
    if (organization.address1 == '' && !isEmpty(regions)) {
      if (regions.length != 0) {
        mapUrl = `https://www.google.com/maps/embed/v1/place?q=${fullAddress}&key=${googleMapKey}`;
      }

    } else if ((!organization.address1 == '' && organization.state == '') || (!organization.address1 == '' && organization.city == '')) {
      mapUrl = `https://www.google.com/maps/embed/v1/place?q=${organization.address1}%20${region}&key=AIzaSyA3Xg-_aRZsRtgBGg38S7SQQhjjEaIOVUg`;

    } else {
      mapUrl = `https://www.google.com/maps/embed/v1/place?q=${organization.address1}%20${organization.city}%20${organization.state}%20${organization.zipcode}&key=AIzaSyA3Xg-_aRZsRtgBGg38S7SQQhjjEaIOVUg`;
    }



    let contentWrapperInnerClass = 'content-wrapper-inner';

    let facebookPageBox = '';
    let organizationDetailFacebookStyle = 'organizationDetail-facebook';

    if(organization.facebook) {
      facebookPageBox = <FBPage appId="306265032880746" href={organization.facebook} width={700} tabs={['timeline', 'events', 'messages']}/>;
    }

    if (!organization.facebook) {
      organizationDetailFacebookStyle = 'organizationDetail-facebook no-facebook';
    }

    let page = <div className="organization-detail-flex-parent">

          <div className="col01">
            <OrganizationDetailTextSection updateContent={false} isEditMode={false} cssSuffix="about" sectionTitle="About" organization={organization} orgAttr="about" />

            <OrganizationDetailConnectSection updateContent={false} isEditMode={false} cssSuffix="connect" sectionTitle="Connect" organization={organization} />


            <div className={organizationDetailFacebookStyle}>
              <div className="organizationDetail-facebookTitle">Facebook</div>
              <div className="organizationDetail-facebookDescription">
                {facebookPageBox}
              </div>
            </div>
          </div>



          <div className="col02">
            <OrganizationDetailTextSection updateContent={false} isEditMode={false} cssSuffix="service" sectionTitle="Service Overview" organization={organization} orgAttr="service_overview" />


            <div className="organizationDetail-location">

              <OrganizationDetailLocationSection
              organization={organization}
              isEditMode={false}
              saveOrganization={false}
              updateContent={false} />

              <div className="organizationDetail-locationDescription">
                <iframe width="100%" height="275" frameBorder="0" style={{border:0}} src={mapUrl}></iframe>
              </div>
            </div>

          </div>

        </div>;


    return (
      <div className="organizationDetail">

        <div className="content-wrapper">
          <OrganizationDetailBanner updateContent={false} isEditMode={false} browser={this.props.browser} organization={featuredOrgFromDB} />
        </div>

        <div className="content-wrapper">
          <div className="organizationDetail-btnWrapperOuter">
            <OrganizationFavBtn
                routing={this.props.routing}
                browser={this.props.browser}
                auth={this.props.auth}
                db_id={this.props.organization.db_id}
              />

            <OrganizationDetailShareButtons routing={this.props.routing}
              browser={this.props.browser}
              auth={this.props.auth}
              organization={this.props.organization}
              />
          </div>
        </div>
        
        <div className="content-wrapper">
          <div className={contentWrapperInnerClass}>
            <div className="organizationDetail-auxWrapper">
              {page}
            </div>
          </div>

        </div>

      </div>
    )
  }
};

function mapStateToProps(state) {
  return state;
};




export default connect(
  mapStateToProps,
  {
    push,
    loadFeaturedOrganizationFromDB
 })(OrganizationDetailFromDB);


// WEBPACK FOOTER //
// ./src/containers/OrganizationDetailFromDB.jsx